export function doesExistValueForKey<T>({
  arr,
  key,
  value,
}: {
  arr: T[]
  key: keyof T
  value: any
}) {
  return arr?.some((obj) => obj[key] === value) ?? false
}
